// Component Name:  Charger component
// Author: Bharath
// Platform: Web
// OS: Windows
// IDE: Visual Studio Code
// Reference: AddLocation
// Date:
// Description: This component is to view all the chargers under the host,
//  charger can be viewed as card or list and can be filtered based on model type, connectors and rating.
// and can be further filtered to online/ offline chargers.
// Dependencies: React,  Redux , API layer to fetch charger
// Interfaces: Accepts props
// Maintenance History:  1.0 - First Version

// Edited by Lavanya S
// [] Introduced view as card/list.
// [] Integrated Filter chargers.
// [21-05-2025] updated radio buttons for the view as to LK Images.

import React, { useEffect, useRef, useState } from "react";
import { Container, Card, CardBody, Row, Col, CardHeader, Input, Label, FormGroup, CustomInput } from "reactstrap";
import { Link } from "react-router-dom";

// RangeSlider
import "nouislider/distribute/nouislider.css";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import MiniWidgets from "../Dashboard/MiniWidgets";
import Cookies from "js-cookie";
//Import Product Images
import chargerDefaultImage from "../../assets/images/product/Picture1.jpg";

import ChargerFilter from "../../components/CommonForBoth/ChargerFilter";
import { chargerSelected, updateStatusFilter } from "../../store/actions";
import CustomPagination from "../../helpers/CustomPagination";
import { MDBDataTable } from "mdbreact";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { CHARGER_LIST_COLUMN_DATA, ITEMS_PER_PAGE } from "../Utility/Constants";
import { loadImages } from "../../api/utils/loadImages";
import Spinner from "../Utility/Spinner";
import { loadChargerRecentStatus, loadChargersWithStatus } from "../../api/utils/loadChargerStatus";
import LKCompletedImg from "../../assets/images/LK_Icons/LK__Completed.svg";
import LKErrorImg from "../../assets/images/LK_Icons/LK__Error.svg";
import LKOfflineImg from "../../assets/images/LK_Icons/LK_Internet Disconnected.svg";
import LKRadioBtnCheck from "../../assets/images/LK_Icons/LK__Radio Button Check.svg";
import LKRadioBtnUnCheck from "../../assets/images/LK_Icons/LK__Radio Button Uncheck.svg";
import { loadLocation } from "../../api/utils/loadLocations";
import { primaryText } from "../Utility/styleComponents";

const Chargers = (props) => {
  const history = useHistory();
  const { chargerIds, locationIds, chargerSelected,updateStatusFilter, paramFilter, statusFilter } = props;
  const [statusData, setStatusData] = useState({ total: 0, active: 0, faulted: 0, offline: 0 });
  const [prevChargerStatus, setPrevChargerStatus] = useState({});
  const chargersDataRef = useRef([]);
  const [filterChargerData, setFilterChargerData] = useState([]);
  const [loadingChargers, setLoadingChargers] = useState(false);
  const [locationData, setLocationData] = useState([]);
  const [viewAs, setViewAs] = useState("card");

  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [imageMap, setImageMap] = useState({});

  const breadcrumbItems = [
    { title: "Charger Management System", link: "#" },
    { title: "Chargers", link: "#" },
  ];

  const reports = [
    {
      image: LKCompletedImg,
      title: "Active",
      value: `${statusData?.active}`,
      totalCount: `${statusData?.total}`,
      rate: "12.33%",
      desc: "From last Month",
      theme: "text-success",
    },
    {
      image: LKErrorImg,
      title: "Faulted",
      value: `${statusData?.faulted}`,
      totalCount: `${statusData?.total}`,
      rate: "10.59%",
      desc: "From last Month",
      theme: "text-danger",
    },
    {
      image: LKOfflineImg,
      title: "Offline",
      value: `${statusData?.offline}`,
      totalCount: `${statusData?.total}`,
      rate: "32.4%",
      desc: "From previous period",
      theme: "text-secondary",
    },
  ];

  // set cookie
  useEffect(() => {
    const cookieView = Cookies.get("view");
    if (!cookieView) {
      Cookies.set("view", "card", { expires: 90 });
    }
    setViewAs(Cookies.get("view"));
  }, []);

  // update cookies on dropdown selection
  useEffect(() => {
    Cookies.set("view", viewAs, { expires: 90 });
  }, [viewAs]);

  useEffect(() => {
      console.log("props chargerIds: ",chargerIds);
    if (chargerIds?.length > 0) {
      handleGetChargerData();
    }
    const intervalId = setInterval(() => {
      handleUpdateRecentStatus();
    }, 6000); // Repeat every 6000ms (6 seconds)
    return () => {
      clearInterval(intervalId);
    };
  }, [chargerIds]);
  useEffect(() => {
    handleLoadLocations();
  }, [locationIds]);
  // load the images map for each location images
  const handleLoadLocations = async () => {
    try {
      const data = await loadLocation(locationIds);
      setLocationData(data);
    } catch (e) {
      console.log("Error Images Data: ", e);
    }
  };
  const handleGetChargerData = async () => {
    try {
      setLoadingChargers(true);
      const { formatData, status } = await loadChargersWithStatus(chargerIds, prevChargerStatus);
      const { anyStatusChanged, recentStatusUpdate, previousStatus } = await loadChargerRecentStatus(formatData, status);
      if (recentStatusUpdate?.length > 0) {
        chargersDataRef.current = recentStatusUpdate;
        setPrevChargerStatus(previousStatus);
        setFilterChargerData(recentStatusUpdate);
        handleLoadImages(recentStatusUpdate);
        updateStatusCards(recentStatusUpdate);
      }
      // const ifAnyFilter = Object.keys(paramFilter).filter((item) => paramFilter[item]?.length > 0);
      // if (ifAnyFilter.length > 0) {
        // getFilteredResults(paramFilter);
        const filtered = applyAllFilters(recentStatusUpdate, statusFilter);
        setFilterChargerData(filtered);
      // }else{
      //   setFilterChargerData(recentStatusUpdate);
      // }
      setLoadingChargers(false);
    } catch (err) {
      console.log("Err fetching the chargers data: ");
    }
  };
  const handleUpdateRecentStatus = async () => {
    try {
      const { anyStatusChanged, recentStatusUpdate, previousStatus } = await loadChargerRecentStatus(chargersDataRef.current, prevChargerStatus);

      if (anyStatusChanged || chargersDataRef.current?.length === 0) {
        // Update main data
        chargersDataRef.current = recentStatusUpdate;
        setPrevChargerStatus(previousStatus);

        // Re-apply current filters and status
        const filtered = applyAllFilters(recentStatusUpdate, statusFilter);

        setFilterChargerData(filtered);
        updateStatusCards(recentStatusUpdate);
      }
    } catch (err) {
      console.log("Err fetching the chargers data: ", err);
    }
  };

  useEffect(() => {
    // Update the total pages when the totalItems changes
    const items = filterChargerData?.length;
    setTotalPages(Math.ceil(items / ITEMS_PER_PAGE));
  }, [totalItems, filterChargerData]);

  // Get the chargersData for the current page using .slice
  const getPaginatedData = () => {
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    return filterChargerData.slice(startIndex, endIndex); // Get the data slice for the current page
  };
  // to load all the images for the charger
  const handleLoadImages = async (chargerData) => {
    const imagesdata = await loadImages(chargerData);
    setImageMap(imagesdata);
  };
  // filter the the chargers based on status to show in the miniwidgets
  const updateStatusCards = (recentStatusUpdate) => {
    const total = recentStatusUpdate?.length;
    const activeStatus = recentStatusUpdate?.filter((item) => item?.status !== "Offline" && item?.status !== "Faulted");
    const faultedStatus = recentStatusUpdate?.filter((item) => item?.status === "Faulted");
    const offlineStatus = recentStatusUpdate?.filter((item) => item?.status === "Offline");
    setStatusData({
      total: total || 0,
      active: activeStatus?.length || 0,
      faulted: faultedStatus?.length || 0,
      offline: offlineStatus?.length || 0,
    });
  };

  // to update the selected charger data
  const selectCharger = (chargerId) => {
    if (chargerId === null) return;
    chargerSelected(chargerId);
  };

  // charger status render (.)
  const renderChargerConnectivityStatus = (chargerStatus) => {
    if (!chargerStatus) return <i className="mdi mdi-checkbox-blank-circle text-danger"></i>;

    if (chargerStatus === "Offline") return <i className="mdi mdi-checkbox-blank-circle text-danger"></i>;

    return <i className="mdi mdi-checkbox-blank-circle text-success"></i>;
  };

  // render the status for each charger,
  // based on the charger status it will return the UI
  const renderChargerStatus = (chargerStatus) => {
    if (chargerStatus == null) return "";

    if (chargerStatus === "Available") return <span className="mt-3 mb-0 text-success">{chargerStatus}</span>;

    if (chargerStatus === "Preparing") return <span className="mt-3 mb-0 text-warning">{chargerStatus}</span>;

    if (chargerStatus === "Charging") return <span className="mt-3 mb-0 bg-success text-white rounded">{chargerStatus}</span>;

    if (chargerStatus === "Finishing") return <span className="mt-3 mb-0 text-warning">{chargerStatus}</span>;

    if (chargerStatus === "Faulted") return <span className="mt-3 mb-0 bg-danger text-white rounded">{chargerStatus}</span>;

    if (chargerStatus === "Offline") return <span className="mt-3 mb-0 text-danger">{chargerStatus}</span>;

    if (chargerStatus === "Reserved") return <span className="mt-3 mb-0 text-primary text-white rounded" >{chargerStatus}</span>;

    return <h5 className="mt-3 mb-0 text-info">{chargerStatus}</h5>;
  };

  const tableData = {
    columns: CHARGER_LIST_COLUMN_DATA,
    rows: filterChargerData?.map((charger) => {
      const { imageId, status, chargerId, vendorId, rating, modelType, protocolType, firmwareVersion, unitRate, connectors } = charger;
      let imageData = imageMap[imageId];
      return {
        rowId: chargerId,
        statusVal: status,
        vendorVal: vendorId,
        ratingVal: rating,
        modelTypeVal: modelType,
        protocolTypeVal: protocolType,
        firmwareVersionVal: firmwareVersion,
        unitRateVal: unitRate,
        image: (
          <div id={chargerId}>
            <img src={imageData || chargerDefaultImage} alt="charger Image" style={styles.rowImage} />
          </div>
        ),
        status: (
          <span style={styles.rowStatus} id={chargerId}>
            {renderChargerStatus(status)}
          </span>
        ),
        chargerId: <p id={chargerId}>{chargerId}</p>,
        vendorId: <p id={chargerId}>{vendorId}</p>,
        rating: <p id={chargerId}>{rating}</p>,
        modelType: <p id={chargerId}>{modelType}</p>,
        protocolType: <p id={chargerId}>{protocolType}</p>,
        // connectors: <p id={chargerId}>{connectors[0]?.connectorType}</p>,
        firmwareVersion: <p id={chargerId}>{firmwareVersion}</p>,
        unitRate: <p id={chargerId}>{unitRate}.0</p>,
      };
    }),
  };

  // handle filter connectors
  const filterConnectors = (chargerConnectors, selectedConn) => {
    const res = chargerConnectors?.some((chargerConn) => {
      return chargerConn === selectedConn;
    });
    return res;
  };
  // filter chargers based on the manufacturer,connectors,type and power
  const handleFilterChargers = (filterParams) => {
    if (!filterParams || filterParams.length === 0) return chargersDataRef.current;
    const { connectors, rating, Type, Location } = filterParams;

    // Apply filters based on the filterParams
    const filterData = chargersDataRef.current?.filter((charger) => {
      // charger connectors contains only the connectorType
      const chargerConnectors = charger?.connectors?.map((conn) => conn.connectorType);
      // const manufacturerMatch = manufacturer?.length === 0 || manufacturer?.includes(charger?.vendorId);
      // Check if connectors is empty or if any of the filter connectors match chargerConnectors
      const connectorsMatch = connectors?.length === 0 || connectors?.some((cn) => filterConnectors(chargerConnectors, cn));
      const powerMatch = rating?.length === 0 || rating?.some((pr) => charger?.rating?.toLowerCase().includes(pr.toLowerCase()));
      const typeMatch = Type?.length === 0 || Type?.some((tm) => charger?.modelType?.toLowerCase().includes(tm.toLowerCase()));
      const locationMatch = Location?.length === 0 || Location?.some((tm) => charger?.locationId.includes(tm));

      return connectorsMatch && powerMatch && typeMatch && locationMatch;
    });

    setCurrentPage(1);
    return filterData;
  };

  // this will be executed based on sort by selection but in co ordination with the filters.
  // to get the filters based on the status.
  const filterChargerByStatus = (status = "All") => {
     updateStatusFilter(status);
    const filtered = applyAllFilters(chargersDataRef.current, status);
    setFilterChargerData(filtered);
    setCurrentPage(1);
  };
  
  // to provide the user with the consistent filtered data
  const applyAllFilters = (data, status) => {
 
    // Start with filtered chargers based on filterParams
    const ifAnyFilter = Object.keys(paramFilter).filter((item) => paramFilter[item]?.length > 0);

    let filteredData =
      ifAnyFilter.length > 0
        ? handleFilterChargers(paramFilter) // Apply filters if filterParams exist
        : data; // If no filters, use all chargers

    // Apply the status filter (All, Available, Offline)
    if (status === "Offline") {
      filteredData = filteredData.filter((charger) => charger?.status === status);
    } else if (status === "Online") {
      filteredData = filteredData.filter((charger) => charger?.status !== "Offline");
    }
    return filteredData;
  };
  // call the filter chargers and reset the status
  const getFilteredResults = (results) => {
    const data = handleFilterChargers(results);
    updateStatusFilter("All");
    setFilterChargerData(data);
  };

  // to reset the filter or clear the filters
  const handleResetFilterOptions = () => {
    setFilterChargerData(chargersDataRef.current);
  };

  // to navigate the user to the charger-details page based on the charger Id
  // for list view
  const handleRowClick = (e) => {
    const parentElement = e?.target?.closest("tr");
    const id = parentElement?.children[0]?.children[0]?.id;
    selectCharger(id);
    history.push("/cms-charger-detail");
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Chargers" breadcrumbItems={breadcrumbItems} />
          <Row>
            <MiniWidgets reports={reports} />
          </Row>

          <Row>
            <Col xl={3} lg={4}>
              <Card>
                <CardHeader className="bg-transparent border-bottom">
                  <h5 className="mb-0">Filters</h5>
                </CardHeader>
                {/* Filter Options */}
                <CardBody>
                  <ChargerFilter
                    // manufacturers={[{ name: "IPEC" }, { name: "IQL" }]}
                    // powerRatings={["3.3", "7.4","22"]}
                    locationsData={locationData}
                    results={getFilteredResults}
                    clearResults={handleResetFilterOptions}
                  />
                </CardBody>
              </Card>
            </Col>
            <Col lg={9}>
              <Card>
                <CardBody>
                  <div>
                    <Row>
                      <Col md={6}>
                        <div>
                          <h5>Chargers & Status</h5>
                        </div>
                      </Col>
                    </Row>
                    {/* select layout */}
                    <FormGroup style={styles.viewAs}>
                      <Label className="font-weight-medium font-family-secondary mt-1">View Layout:</Label>
                      {
                        <div style={{ display: "flex", gap: "10px" }}>
                          {["card", "list"].map((opt) => (
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", cursor: "pointer" }} key={opt}>
                              <label>
                                <img
                                  alt={viewAs === "card" ? "checked Img" : "unchecked Img"}
                                  src={viewAs === opt ? LKRadioBtnCheck : LKRadioBtnUnCheck}
                                  style={{ width: "20px", height: "20px", cursor: "pointer" }}
                                  onClick={() => setViewAs(opt)}
                                />
                              </label>
                              <span onClick={() => setViewAs(opt)} style={{ fontSize: "16px", marginBottom: "8px" }}>
                                {opt}
                              </span>
                            </div>
                          ))}
                        </div>
                      }

                      {/* <CustomInput type="radio" id="card" name="viewAs" value="card" label="Card View" checked={viewAs === "card"} onChange={() => setViewAs("card")} />
                      <CustomInput type="radio" id="list" name="viewAs" value="list" label="List View" checked={viewAs === "list"} onChange={() => setViewAs("list")} /> */}
                    </FormGroup>
                    {/* choose sort by */}
                    <ul className="list-inline mt-1 mb-3 ecommerce-sortby-list">
                      <li className="list-inline-item">
                        <span className="font-weight-medium font-family-secondary">Sort by:</span>
                      </li>
                      <li className={`list-inline-item  ml-1 ${statusFilter === "All" ? "active" : ""}`}>
                        <Link to="#" onClick={() => filterChargerByStatus()} className={statusFilter === "All" ? "active" : ""}>
                          All
                        </Link>
                      </li>
                      <li className={`list-inline-item  ml-1 ${statusFilter === "Online" ? "active" : ""}`}>
                        <Link to="#" onClick={() => filterChargerByStatus("Online")}>
                          Online
                        </Link>
                      </li>
                      <li className={`list-inline-item  ml-1 ${statusFilter === "Offline" ? "active" : ""}`}>
                        <Link to="#" onClick={() => filterChargerByStatus("Offline")}>
                          Offline
                        </Link>
                      </li>
                    </ul>
                    {/* Charger Display section, if charger not available then loader will be displayed else charger based on what layout they have selected 
                    (either card or list)*/}
                    {loadingChargers ? (
                      <div style={styles.loaderContainer}>
                        <Spinner />
                      </div>
                    ) : chargersDataRef.current?.length === 0 ? (
                      <div style={{ height: "200px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <h5>No chargers</h5>
                      </div>
                    ) : viewAs === "card" ? (
                      <>
                        <Row className="no-gutters">
                          {getPaginatedData().map((charger, index) => {
                            const { _id, chargerId, imageId, modelType, connectors, rating, name } = charger;
                            // const imageData = handleGetImage(imageId)
                            let imageData = imageMap[imageId];

                            const model = modelType || "";
                            const rate = rating || "";
                            const connectorType = connectors?.length > 0 ? connectors[0]?.connectorType : "";

                            return (
                              <Col xl={4} sm={6} key={_id}>
                                <div className="product-box">
                                  <Link
                                    to="cms-charger-detail"
                                    className="text-dark"
                                    onClick={() => {
                                      selectCharger(chargerId);
                                    }}
                                  >
                                    <div className="product-img">
                                      <div className="product-like">
                                        <span style={styles.cardStatus}>{renderChargerConnectivityStatus(charger.status)}</span>
                                      </div>
                                      <img src={imageData || chargerDefaultImage} style={styles.cardImgHeight} alt="" className="img-fluid mx-auto d-block" />
                                    </div>

                                    <div className="text-center">
                                      <p className="font-size-13 m-0 text-primary">Id: {chargerId}</p>
                                      <h4 className="font-size-15 font-bold m-0">{name}</h4>
                                      <p className="font-size-12">{`${model} ${"  "} ${rate}  ${"  "} ${connectorType}`}</p>

                                      <h5> {renderChargerStatus(charger.status)}</h5>
                                    </div>
                                  </Link>
                                </div>
                              </Col>
                            );
                          })}
                        </Row>
                        <Row className="mt-4">
                          <Col sm={6}>
                            <div>
                              <p className="mb-sm-0 mt-2">
                                Page <span className="font-weight-bold">{currentPage} </span>
                                Of <span className="font-weight-bold">{totalPages}</span>
                              </p>
                            </div>
                          </Col>
                          <Col sm={6}>
                            <div className="float-sm-right">
                              <CustomPagination totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                            </div>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      <>
                        <div>
                          <MDBDataTable hover responsive data={tableData} style={styles.pointer} onClick={handleRowClick} />
                        </div>
                      </>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const styles = {
  loaderContainer: { height: "250px" },
  pointer: { cursor: "pointer", textAlign: "center" },
  cardImgHeight: { height: 200 },
  cardStatus: { border: "1px solid #efefef", borderRadius: "50%", padding: "10px 12px" },
  viewAs: { display: "flex", gap: "15px", marginTop: "4px", marginBottom: "0px" },
  rowImage: { width: 40, height: 40 },
  rowStatus: { fontSize: 15, textAlign: "center" },
};
const mapStateToProps = (state) => {
  // chargerIds: state.ChargerManagement.chargerIds,
  // param: state.ChargerManagement.chargerFilter.param,
  // // chargerFilter: state.ChargerManagement.chargerFilter,
  // locationIds: state.LocationManagement.locationIds,
  const { chargerIds } = state.ChargerManagement;
  const { param, status } = state.ChargerManagement.chargerFilter;
  const { locationIds } = state.LocationManagement;
  const paramFilter = param;
  const statusFilter = status;

  return { chargerIds, paramFilter, statusFilter, locationIds };
};

const mapDispatchToProps = (dispatch) => ({
  chargerSelected: (payload) => dispatch(chargerSelected(payload)),
  updateStatusFilter: (payload) => dispatch(updateStatusFilter(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Chargers);
